module.exports = __webpack_public_path__ + "img/门禁控制器 (6).bd27f131.jpg";